import React, { useState } from 'react';
import { t } from '@lingui/macro';

import { Search } from '@rover/icons';
import { Box, Text } from '@rover/kibble/core';
import { DSTokenMap } from '@rover/kibble/styles';
import LocationInput from '@rover/react-lib/src/containers/LocationInputContainer';

import { LocationData, LocationInputProps } from './PlatformLocationInputInterface';

const PlatformLocationInputWeb: React.FC<LocationInputProps> = ({
  inputValue,
  onChange,
  errorMessage,
  setValue,
}) => {
  const [controlledInputValue, setControlledInputValue] = useState<string | undefined>(undefined);
  const [hasTyped, setHasTyped] = useState<boolean>(false);

  const handleInputChange = (data: {
    value?: string;
    postalCode?: string;
    latitude?: number;
    longitude?: number;
  }): void => {
    const locationData: LocationData = {
      value: data.value || '',
      postalCode: data.postalCode,
      latitude: data.latitude,
      longitude: data.longitude,
      address: data.value,
    };
    onChange(locationData);
    setHasTyped(false);
  };

  const handleBlur = (): void => {
    if (hasTyped) {
      setControlledInputValue('');
      setValue('addressLine1', '');
    }
  };

  const handleOnInputChange = (value: string): void => {
    setHasTyped(true);
    setControlledInputValue(value);
  };

  return (
    <Box>
      <Text size="200" mb="3x" fontWeight="semibold">
        {t`Address`} *
      </Text>
      <LocationInput
        inputHeight="48px"
        enableLatLng
        inputValue={inputValue}
        onChange={handleInputChange}
        onInputChange={handleOnInputChange}
        onBlur={handleBlur}
        controlledInputValue={controlledInputValue}
        placeholder={t`Enter street address`}
        validationType="inline"
        renderIcon={() => <Search height={DSTokenMap.SPACE_5X} />}
        renderIconAlignment="right"
        includeHomeAddress={false}
        validationError={errorMessage}
      />
    </Box>
  );
};

export default PlatformLocationInputWeb;
